
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-de-privacidade",
      function () {
        return require("private-next-pages/politica-de-privacidade/index.ts");
      }
    ]);
  